type TitleSuggestion = {
  score: number;
  title: string;
};

export const getChapterTitle = (title_suggestions: TitleSuggestion[] | null, index: number) => {
  if (!title_suggestions || title_suggestions.length === 0) {
    return `Chapter ${index + 1}`;
  }

  const maxScore = Math.max(...title_suggestions.map((sugestion) => sugestion.score));
  const best = title_suggestions.find((sugestion) => sugestion.score === maxScore)!;

  return best?.title ?? `Chapter ${index + 1}`;
};
